import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    "& .recharts-default-legend": {
      marginLeft: "70px !important",
    },
    "& .recharts-legend-item": {
      marginRight: "20px !important",
    },
    "& .recharts-legend-item-text": {
      color: theme.custom.color.blackRussian + " !important",
    },
    "& .recharts-surface": {
      marginBottom: "3px",
    },
  },
  title: {
    fontSize: "16px",
    borderBottom: theme.custom.border.primary,
  },
  chartContainer: {
    width: "100% !important",
    height: "160px !important",
  },
  missing: {
    backgroundColor: theme.custom.color.silver,
    borderColor: theme.custom.color.blackRussian,
    borderWidth: "1px",
    borderStyle: "solid",
    margin: "10px 10px 10px 60px",
    height: "80px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
